import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Chevron from '../../Chevron/Chevron';
import * as styles from './BreadCrumbs.css';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

const cx = classNames.bind(styles);
/**
 * component to display any HTML elements or Components within it,a wrapper compoenent for Crumbs.
 * Currently it supports separator config and . Also support
 * theming
 *
 * Crumbs can be used at many places. E.g Departments,Product Details, Search/Browse
 */

class Crumbs extends Component {
    /**
     * Supported React properties
     * @type {Object}
     */
    static propTypes = {
        /**
         * Children nodes of crumbs
         * @type {node}
         */
        children: PropTypes.node,

        /**
         * Active crumb
         * @type {node}
         */
        isActive: PropTypes.bool,

        /**
         * separator for each crumb
         * @type {node}
         */
        separator: PropTypes.string,

        /**
         * themeConfig provides custom theming capabilities
         * @mandatory prop
         * takes default theming or user defined custom theme
         * @type {object}
         */
        themeConfig: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),

        /**
         * path link to take user to the respective URL
         * @mandatory prop
         * @type {string}
         */
        path: PropTypes.string,

        /**
         * it is a click event property. If assigned click event
         * will be attached to crumb link
         */
        onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

        analyticsCallback: PropTypes.func,
        dataIndex: PropTypes.number,
    };

    /** @properties {Default set up} [optonal props set] */
    static defaultProps = {
        children: {},
        isActive: false,
        separator: 'none',
        themeConfig: [],
        path: null,
        onClick: false,
        analyticsCallback: () => {},
        dataIndex: 0,
    };

    constructor(props) {
        super(props);
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler(e) {
        e.stopPropagation();

        const { onClick, path, analyticsCallback, dataIndex } = this.props;

        /* istanbul ignore else */
        if (typeof analyticsCallback === 'function') {
            analyticsCallback(dataIndex);
        }
        /* istanbul ignore else */
        if (typeof onClick === 'function') {
            onClick(e);
        } else {
            e.preventDefault();
            // soft route to the target url
            /*
              it will hard reload always
            */
            window.location = path;
        }
    }

    createLink(crumbThemeClass, children, path, dataIndex) {
        const linkProps = {
            className: crumbThemeClass,
            onClick: this.clickHandler,
            href: path,
            key: dataIndex,
        };

        return (
            <a {...linkProps}>
                <span className={styles.textNode}>{children}</span>
            </a>
        );
    }

    createArrow = () => {
        const { separator, dataIndex } = this.props;
        const chevronStyle = dataIndex === 0 ? ['hidden'] : [];
        return separator === 'arrow' || separator === 'reverseArrow' ? (
            <span className={dt(['my-0', 'mx-1', ...chevronStyle])}>
                <Chevron direction={separator} containerStylesOverride={chevronStyle} />
            </span>
        ) : /* istanbul ignore next */
        null;
    };

    /**
     * Renders all the children inside it
     * @return {[type]} [description]
     */
    render() {
        /** Props abstracted */
        const { themeConfig, children, isActive, separator, path, dataIndex } = this.props;
        const separatorClass = separator !== 'none' || false;
        /**
         * Based on separator the class is added dynamically
         * @type {[type]}
         */
        const crumbThemeClass = cx({
            [`${themeConfig.crumbLinksClass}`]: true,
            [`${styles[separator]}`]: separatorClass,
        });

        let crumbs;

        if (isActive) {
            crumbs = (
                <li
                    className={[
                        cx(
                            themeConfig.crumbListItemClass,
                            crumbThemeClass,
                            themeConfig.crumbActiveClass
                        ),
                        dt(['sm:!flex']),
                    ].join(' ')}
                    data-automation-id="breadcrumb-active"
                >
                    {this.createArrow()}
                    {children}
                </li>
            );
        } else {
            crumbs = (
                <li
                    className={[themeConfig.crumbListItemClass, dt(['sm:!flex'])].join(' ')}
                    data-automation-id="breadcrumb-normal"
                >
                    {this.createArrow()}
                    {this.createLink(crumbThemeClass, children, path, dataIndex)}
                </li>
            );
        }

        return crumbs;
    }
}

export default Crumbs;
